import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import { useStore, useTranslate, useConfirm } from '@/composables/use-globals';
import { useGroupMembers } from '@/composables/use-group-members';
import { Member, MemberAlert } from '@/models/member';
import { Group } from '@/models/group';
import GroupedMemberView from '@/components/common/GroupedMemberView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberAlerts',
  setup(__props) {

const translate = useTranslate();
const confirm = useConfirm();
const store = useStore();
const route = useRoute();
const { groupId, groupLink, groupName, groupTotal, groupMembers } = useGroupMembers(store);

function getMembersWithAlertType(type: string) {
  return groupMembers.value.filter(member => member.alerts && member.alerts.find(alert => alert.type === type));
}

function getAlertHeader(type: string) {
  return translate('members.alert_' + type.toLowerCase());
}

const membersWithMedicalConditions = computed<Array<Member>>(() => {
  return groupMembers.value.filter(
    member =>
      (member.medical_conditions && member.medical_conditions.length) ||
      (member.medical_notes && member.medical_notes !== '')
  );
});

const alertTypes = computed(() => {
  const alerts = groupMembers.value
    .flatMap((member: Member) => {
      if (member.alerts) {
        return member.alerts.map((alert: MemberAlert) => {
          return alert.type;
        });
      }
      return [];
    })
    .filter((m: any) => m !== null);

  return [...new Set(alerts)];
});

return { __sfc: true,translate, confirm, store, route, groupId, groupLink, groupName, groupTotal, groupMembers, getMembersWithAlertType, getAlertHeader, membersWithMedicalConditions, alertTypes, GroupedMemberView }
}

})